export default {
    Metadata: {
        Name: "HasAttachment",
        Description: "Returns true if the attachment column has a file, otherwise returns false.",
        Syntax: "HasAttachment(<column>)",
        Keywords: ['Logical'],
        Author: "DataVoke, Inc.",
    },
    execute(column) {
        if (!(column instanceof app.dv.entities.GridValue)) {
            console.warn('Invalid type of value specified to function - Check that you are using "<" and ">" around the column name in expression.');
            return false;
        }

        // get the current dynamic value from the grid value; could be a unmodified or edited value.
        let value = null;
        if (column.dynamicValueEdit != null) {
            value = column.dynamicValueEdit;
        }
        else {
            value = column.dynamicValue;
        }

        if (value == null) {
            console.warn('Invalid type of value specified to function - Check that you are using "<" and ">" around the column name in expression.');
            return false;
        }

        switch (value.DataType) {
            case app.dv.types.PropertyDataType.Binary:
                if (value.ValueMetadata == null || value.ValueMetadata === '') {
                    // no value metadata; no file - null.
                    return false;
                }
                // use a parse that supports NaN as some metadata may contain it; this would error in regular JSON.parse()
                let nodes = JSON.parseMore(value.ValueMetadata);
                if (!Array.isArray(nodes)) {
                    // invalid value metadata; no file - null.
                    console.warn('Specified field has invalid metadata; please check data.');
                    return false;
                }

                let data = nodes.find(node => node.Key === 'FileDate');
                // if we found a node for the file size, there is a file, even if the size is 0.
                return data != null && data.Value !== 'N/A';

            default:
                console.warn('Invalid type of column specified to function; column is not of type "Attachment"');
                return false;
        }
    },
};

